// extracted by mini-css-extract-plugin
export var cardLayout = "_ad-1";
export var paginationContainer = "_ad-0";